import components from '../components';
import DonsController from './dons.controller';
import DonsTemplate from './dons.template.html';

components
  .component('dons', {
    bindings: {},
    controller: DonsController,
    template: DonsTemplate
  });



// WEBPACK FOOTER //
// ./src/app/components/dons/dons.component.js